module.exports = __webpack_public_path__ + "img/Bard.6d85c5e0.png";